// System Imports
import React, { useState } from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";

// Global Var Imports
import dimensions from "styles/dimensions";
import colors from "styles/colors";

//Component Imports
import Logo from "components/_ui/Logo";
import NavbarLinks from "./NavbarLinks"


const NavbarContainer = styled("header")`
  margin: 0;
  padding: 0;
  border: 0;
  
  position: fixed;
  width: 100%;
  background-color: #fff;
  z-index: 1000;
  display: block;
`

const NavbarMenu = styled("div")`

`

const NavbarDisplay = styled("div")`
  margin: 0;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px 0;
  text-align: right;
  zoom: 1;
  
  @media(min-width: ${dimensions.minwidthTablet}px) {
    padding: 20px 0;
  }

  @media(min-width: ${dimensions.minwidthDesktop}px) {
    padding: 30px 0;
  }

  .logoLink {
    height: 24px;
    float: left;
    position: relative;
    z-index: 1;
    margin-left: 16px;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      float: none;
      position: absolute;
      left: 30px;
      margin-left: 0;
      min-height: 24px;
      max-height: 31px;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      height: 31px;
      left: 30px;
    }
  }

  a.quoteLink {
    margin: 0;
    padding: 0;
    cursor: pointer;

    overflow: hidden;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    text-decoration: none;
    color: #303030;
    transition: opacity .3s;
    font-size: calc(.625rem + .375vw - 1.2px);
    letter-spacing: calc(.125rem + .25vw - .8px);
    text-transform: uppercase;
    font-weight: 700;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      line-height: 30px;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      line-height: 40px;
    }

    &:before {
      box-sizing: border-box;
      content: attr(letters);
      position: absolute;
      z-index: 2;
      overflow: hidden;
      color: #8f8f8f;
      white-space: nowrap;
      width: 0;
      transition: width .4s;
    }

    &:hover:before {
      width: 100%;
    }
  }
`

const NavToggle = styled("div")`
  margin: 0;
  padding: 0;

  float: right;
  width: 18.75%;
  text-align: center;

  @media(min-width: ${dimensions.minwidthDesktop}px) {
    width: 12.5%;
  }

  button {
    padding: 0;
    margin: 0;
    position: relative;
    appearance: none;
    border: none;
    cursor: pointer;
    background-color: rgba(0,0,0,0);
    z-index: 1;
    vertical-align: middle;
    height: 24px;
    width: 24px;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      width: 30px;
      height: 30px;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      width: 31px;
      height: 31px;
    }
  }

  div.toggleBlock {
    margin: 0;
    padding: 0;
    border: 0;

    position: relative;
    padding-bottom: 100%;

    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;    
      transform: translate(-50%,-50%);
      display: block;
      width: 6px;
      height: 6px;
    }
  }

  div.toggleLines {
    margin: 0;
    padding: 0;
    border: 0;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: width .25s ease-in-out 0s;

    &:before, &:after {
      content: "";
      display: block;
      height: 2px;
      margin-left: auto;
      background-color: #303030;
      transform-origin: center;
      transition: width .25s ease-in-out 0s,margin .25s ease-in-out 0s,transform .25s ease-in-out 0s,-webkit-transform .25s ease-in-out 0s;
    }

    &:before {
      width: 24px;
      transform: translate3d(0,-2px,0);
    }

    &:after {
      width: 14px;
      transform: translate3d(0,2px,0);
    }
  }

  div.toggleBlock:hover div.toggleLines:after {
    width: 24px;
  }
`

const Navbar = () => {
  const [navbarOpen, setNavbarOpen] = useState(false)

  return(
    <NavbarContainer
      data-sal="slide-down"
      data-sal-duration="500"
      data-sal-delay="150"
      data-sal-easing="ease-out"    
    >
        <NavbarDisplay>
            <Link className="logoLink" to="/">
              <Logo/>
            </Link>
            <a href="/" className="quoteLink" letters="Get in touch">
              Get in touch
            </a>
            <NavToggle
              navbarOpen={navbarOpen}
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <button>
                <div className="toggleBlock">
                  <div className="toggleLines"></div>
                </div>
              </button>
            </NavToggle>
        </NavbarDisplay>

        <NavbarMenu>

        </NavbarMenu>
    </NavbarContainer>
  )
}

export default Navbar;